import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SideMenuComponent } from '@shared/components/side-menu';
import { VersionsComponent } from '@shared/components/versions';

import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AppService],
  imports: [SideMenuComponent, RouterOutlet, VersionsComponent, NgClass],
})
export class AppComponent {
  readonly #appService = inject(AppService);

  public readonly versions = this.#appService.versions;
  public readonly showSideMenu = this.#appService.showSideMenu;
  public readonly showOnlyFeVersion = this.#appService.showOnlyFeVersion;
}
